import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ICompanyApi } from './base/companyApi';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { CompanyFilterRequest } from '../models/request';

const baseRoute: string = 'Company';

export class CompanyApi extends ICompanyApi {
  getDomain(
    request: CompanyFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }
  getDomainAll(
    request: CompanyFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainAll`, { params: request });
  }
}
